// Javascript

if (window.matchMedia("(hover: hover)").matches) {
	document.getElementById('app').classList.add('hover');
}

function resizeIframe(iframe) {
  let ioffset = 100;
  let itall = iframe.contentWindow.document.body.scrollHeight;
  // console.log(itall);
  iframe.height = itall + ioffset + "px";
  // console.log(iframe.height);
}



// function searchToggle() {
//   
// }
// 
// function searchIgnite() {
//   const headsearch document.getElementById('headsearch');
//   headsearch.addEventListener('click',function(e){
//     showAnime();
//     e.preventDefault();
//   });
// }

function showMenu() {
  if (document.getElementById('mainNav')) {
    
    let menuNavButton = document.getElementById('menuNavButton');
    menuNavButton.setAttribute('aria-expanded', 'true');
    
    const hamburger = document.getElementById('hamburger-9');
    hamburger.classList.add('is-active');
    
    const header = document.getElementById('header');
    header.classList.add('shownav');
    
    let erstNav = document.getElementById('firstNav');
    setTimeout( function(e) {
      erstNav.classList.add('hello');
    }, 300);

    if (document.getElementById('jewellerysort')) {
      let jewelleryNav = document.getElementById('jewellerysort');
      setTimeout( function(e) {
        jewelleryNav.classList.add('hello');
      }, 900);
    }

    if (document.getElementById('infoNav')) {
      let infoNav = document.getElementById('infoNav');
      setTimeout( function(e) {
        infoNav.classList.add('hello');
      }, 900);
    }

    if (document.getElementById('collectionsort')) {
      let collectionNav = document.getElementById('collectionsort');
      setTimeout( function(e) {
        collectionNav.classList.add('hello');
      }, 600);
    }

    if (document.getElementById('byPrice')) {
      let byPrice = document.getElementById('byPrice');
      setTimeout( function(e) {
        byPrice.classList.add('hello');
      }, 900);
    }

  }
}

function hideMenu() {
  if (document.getElementById('mainNav')) {
    
    let menuNavButton = document.getElementById('menuNavButton');
    menuNavButton.setAttribute('aria-expanded', 'false');
    
    const hamburger = document.getElementById('hamburger-9');
    hamburger.classList.remove('is-active');
    
    const header = document.getElementById('header');
    
    // setTimeout( function(e) {
      header.classList.remove('shownav');
    // }, 900);
    
    
    let erstNav = document.getElementById('firstNav');
    setTimeout( function(e) {
      erstNav.classList.remove('hello');
    }, 100);

    if (document.getElementById('jewellerysort')) {
      let jewelleryNav = document.getElementById('jewellerysort');
        jewelleryNav.classList.remove('hello');
    }

    if (document.getElementById('infoNav')) {
      let infoNav = document.getElementById('infoNav');
        infoNav.classList.remove('hello');
    }

    if (document.getElementById('collectionsort')) {
      let collectionNav = document.getElementById('collectionsort');
      setTimeout( function(e) {
        collectionNav.classList.remove('hello');
      }, 50);
    }

    if (document.getElementById('byPrice')) {
      let byPrice = document.getElementById('byPrice');
        byPrice.classList.remove('hello');
    }

  }
}

function showfooterMenu() {
  if (document.getElementById('footNav')) {

    let footNav = document.getElementById('footNav');

    setTimeout( function(e) {
      footNav.classList.add('hello');
    }, 120);
  }
}

function hideFooterMenu() {
  if (document.getElementById('footNav')) {

    let footNav = document.getElementById('footNav');

    setTimeout( function(e) {
      footNav.classList.remove('hello');
    }, 120);
  }
}

// function footerScripts() {
//   if (document.getElementById('footer')) {
//   var waypointFirst = new Waypoint({
//     element: document.getElementById('footer'),
//     handler: function(direction) {
//       if (direction === 'down') {
//         //var elDistanceToTop = window.pageYOffset + el.getBoundingClientRect().top;
//         var disTanceA = document.getElementById('footer');
//         // var distanceTop = disTanceA.getBoundingClientRect().top;
//         var elDistanceToTop = window.pageYOffset + disTanceA.getBoundingClientRect().top;
//         // let disTance = disTanceA.scrollTop;
//         window.scrollTo({
//           top: elDistanceToTop,
//           left: 0,
//           behavior: 'smooth'
//         });
//       }
//     },
//     offset: 200 
//   })
// 
//   }
// }


function headerScripts() {
  let header = document.getElementById('header');
  var waypointHead = new Waypoint({
  element: document.getElementById('content'),
  handler: function(direction) {
    if (direction === 'down') {
      header.classList.add('stickery');
      hideMenu();
    }
    if (direction === 'up') {
      header.classList.remove('stickery');
      showMenu();
    }
  },
  offset: -200
  })
}

headerScripts();

document.addEventListener("DOMContentLoaded", function(event) { 

    var simulateClickEvent = function (elem) {
      var evt = new MouseEvent('click', {
        bubbles: true,
        cancelable: true,
        view: window
      });
      var canceled = !elem.dispatchEvent(evt);
    };
    
    
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(0));
    
    if (params.has('delivery')) {
      var deliveryAccordion = document.querySelector('#ac-1 h2');
      simulateClickEvent(deliveryAccordion);
    }

    // Profile page has some odd layout stuff
    function profileHeights(e) {
      let headerHeight = document.getElementById('header').offsetHeight;
      document.getElementById('firstProfile').style.height = headerHeight+'px';
    }

    if (document.getElementById('firstProfile')) {
      profileHeights();
    }
    
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 100) {
      } else {
        showMenu();
    }

    function showAnime() {

      // Homepage Animation Triggers
      let aLogo = document.getElementById('aLogo');
      let aNumbers = document.getElementById('aNumbers');
      let aVolText = document.getElementById('aVolText');
      let aIntro = document.getElementById('aIntro');
      let firstNav = document.getElementById('firstNav');
      let logo = document.getElementById('logo');

      aIntro.classList.add('hello');

      setTimeout( function(e) {
        aVolText.classList.add('down');
      }, 4000);

      setTimeout( function(e) {
        aLogo.classList.add('hello');
        aNumbers.classList.add('hello');
      }, 7000);

      setTimeout( function(e) {
        aLogo.classList.add('goleft');
        aVolText.classList.add('goodbye');
      }, 17000);

      setTimeout( function(e) {
        firstNav.classList.add('hello');
        logo.classList.add('hello');
      }, 19250);

    }


    if (document.getElementById('kickoff')) {

      let kickOff = document.getElementById('kickoff');

      kickOff.addEventListener('click',function(e){
        showAnime();
        e.preventDefault();
      });
      
    }

    //Campaigns Page Animation triggers
    if (document.getElementById('trigster')) {
      const trigster = document.getElementById('trigster');
      const undoner = document.getElementById('undoner');
      trigster.addEventListener('click',function(e){
              fallDownOne();
      });
      undoner.addEventListener('click',function(e){
              goBackUp();
      });
    }


    if (document.getElementById('menuNavButton')) {
      var navButton = document.getElementById('menuNavButton');
      navButton.addEventListener('click', function() {
        let expanded = this.getAttribute('aria-expanded') === 'true' || false;
        this.setAttribute('aria-expanded', !expanded);
        const header = document.getElementById('header');
        const hamburger = document.getElementById('hamburger-9');
        // console.log(expanded);
        if (this.getAttribute('aria-expanded') === 'true') {
          showMenu();
        } else {
          hideMenu();
        }
      });
    }
    if(document.getElementById('menuNavButton')) {
      // Make categories stick only
      const smobile = window.matchMedia("(max-width: 960px)");

      if (smobile.matches) {
        stickiest();
      } 
      window.onscroll = function() {
        if (smobile.matches) {
          stickiest();
        }
    };

    function stickiest() {
      const menuNavButton = document.getElementById('menuNavButton');
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        if (menuNavButton.getAttribute('aria-expanded') === 'true') {
          menuNavButton.click();
        }
      } else {
        if (menuNavButton.getAttribute('aria-expanded') === 'false') {
          menuNavButton.click();
        }
      }
    }

  }

    function goBack() {
      window.history.back();
    }

    if (document.getElementById('back_button')) {
      const back_button = document.getElementById('back_button');
      back_button.addEventListener('click',function(e) {
        goBack();
      });
    }
    
    // Cookies Nom Nom
    
    function maxAgeToGMT (nMaxAge) {
      return nMaxAge === Infinity ? "Fri, 31 Dec 9999 23:59:59 GMT" : (new Date(nMaxAge * 1e3 + Date.now())).toUTCString();
    }

    if (document.getElementById('productSlides')) {
      const galleryHelp = document.getElementById('galleryHelp');
      const imageHelp = document.getElementById('imageHelp');
      if (docCookies.hasItem("imageHelp")) { 
        // tumbleweed
      } else {
        imageHelp.classList.add('showme');
        galleryHelp.addEventListener('click',function(e) {
          docCookies.setItem("imageHelp", "Seen", maxAgeToGMT(31536000));
          imageHelp.classList.remove('showme');
        });
      }
    }
    
    if (document.getElementById('geopops')) {
      const geopop = document.getElementById('geopops');
      if (docCookies.hasItem("geoPop")) { 
        // tumbleweed
      } else {
        console.log('no cookies today');
        // fire the iframe
        setTimeout(function() {
          var linkSrc = '/modals/geopop';
          var modal2 = document.getElementById("geopops"); 
          if(!document.getElementById("ayeframe")) {
              var iframe = document.createElement('iframe');
              iframe.src = linkSrc;
              iframe.id = "ayeframe";
              iframe.scrolling = "no";
              modal2.appendChild(iframe);
            }
          modal2.classList.add("active");
          resizeIframe(iframe);  
        }, 7000); 
        let unannoy = document.querySelector(".unannoy");
        unannoy.addEventListener('click',function(e) {
          docCookies.setItem("geoPop", "Seen", maxAgeToGMT(604800));
          if (geopop.classList.contains("active")) {
            geopop.classList.remove("active");
          }
        });
        
        geopop.addEventListener('click',function(e) {
          if (geopop.classList.contains("active")) {
            docCookies.setItem("geoPop", "Seen", maxAgeToGMT(604800));
            geopop.classList.remove("active");
          }
        });
        
      }
    }
    window.addEventListener("load", function() {
      
      if (document.getElementById('emailpop')) {
        console.log('popup coming... sorry');
        const emailpop = document.getElementById('emailpop');
        if (docCookies.hasItem("emailPop") || docCookies.hasItem("emailPopInteracted")) { 
          // tumbleweed
        } else {
          console.log('no cookies today');
          // fire the iframe
          setTimeout(function() {
            var linkSrc = '/modals/emailpop';
            var modal3 = document.getElementById("emailpop"); 
            if(!document.getElementById("ayeframe")) {
                var iframe = document.createElement('iframe');
                iframe.src = linkSrc;
                iframe.id = "ayeframe";
                iframe.scrolling = "no";
                modal3.appendChild(iframe);
            }
            setTimeout(function() {
              modal3.addEventListener('DOMContentLoaded', function () {
                modal3.classList.add("active");
                resizeIframe(iframe);
              });
            }, 2000); 
          }, 5000); 
          
          let closer = document.querySelector(".closer");
          closer.addEventListener('click',function(e) {
            docCookies.setItem("emailPop", "Seen", maxAgeToGMT(604800));
            if (emailpop.classList.contains("active")) {
              emailpop.classList.remove("active");
            }
          });
        }
      }
    });
    
    // Use forms callback to add a cookie if successfully submitted
    if (document.getElementById('newsletterForm')) {
      const form = document.getElementById('newsletterForm');
      form.addEventListener('freeform-ready', function(event) {
        const freeform = event.target.freeform;
        freeform.addOnSuccessfulAjaxSubmit((event, form, response) => {
          docCookies.setItem("emailPopInteracted", "Clicked", maxAgeToGMT(31536000));
          console.log("submitted and dandy");
        })
      }); 
    }

    // refresh waypoints when mixitup has finished dickin around
    if (document.getElementById('grid')) {
      const grdlock = document.getElementById('grid');
      grdlock.addEventListener('mixEnd', function(e){
        Waypoint.refreshAll();
      });
    }

    if (document.getElementById('footer-customerservice')) {

      function resetFooterStates() {
        let footerContaina = document.getElementById('footer-content');
        document.querySelectorAll('.footernav .nav-items li a').forEach( function(footerMenus) {
          footerMenus.classList.remove('active');
        });
        document.querySelectorAll('.footer-content div').forEach( function(footerContent) {
          footerContent.classList.remove('ola');
        });
        footerContaina.classList.remove('fade-out-top');
      }
      
      if (document.getElementById('cServices')) {
        let cServices = document.getElementById('cServices');
        let footerCustomerservice = document.getElementById('footer-customerservice');
        cServices.addEventListener('click',function(e) {
          resetFooterStates();
          
          setTimeout( function() {
            cServices.classList.add('active');
            footerCustomerservice.classList.add('ola');
          }, 100);

          setTimeout( function() {
            Waypoint.refreshAll();
          }, 300);

          e.preventDefault();
        });
      }

      if (document.getElementById('Contact')) {
        let Contact = document.getElementById('Contact');
        let footerContact = document.getElementById('footer-contact');
        Contact.addEventListener('click',function(e) {
          resetFooterStates();
          
          setTimeout( function() {
            Contact.classList.add('active');
            footerContact.classList.add('ola');
          }, 100);

          setTimeout( function() {
            Waypoint.refreshAll();
          }, 300);

          e.preventDefault();
        });
      }

      if (document.getElementById('Privacy')) {
        let Privacy = document.getElementById('Privacy');
        let footerPrivacy = document.getElementById('footer-privacy');
        Privacy.addEventListener('click',function(e) {
          resetFooterStates();
          
          setTimeout( function() {
            Privacy.classList.add('active');
            footerPrivacy.classList.add('ola');
          }, 100);

          setTimeout( function() {
            Waypoint.refreshAll();
          }, 300);

          e.preventDefault();
        });
      }

      if (document.querySelector('.accordion-container')) {
        // Waypoints accordion resets
        document.querySelectorAll('.accordion-container .ac').forEach( function(accorNav) {
          accorNav.addEventListener('click',function() {
            setTimeout( function() {
              Waypoint.refreshAll();
            }, 800);
          });
        });
      }

      if (document.getElementById('Subscribe')) {
        let Subscribe = document.getElementById('Subscribe');
        let footerSubscribe = document.getElementById('footerSubscribe');
        Subscribe.addEventListener('click',function(e) {
          resetFooterStates();
          
          setTimeout( function() {
            Subscribe.classList.add('active');
            footerSubscribe.classList.add('ola');
          }, 100);

          e.preventDefault();
        });
      }
      var accordion = new Accordion('.accordion-bag');
      var accordion = new Accordion('.accordion-bog');

    }

    if(document.getElementById("appoint")) {
      
      let appoint = document.getElementById("appoint");

      appoint.addEventListener('click',function(e) {
        var linkSrc = appoint.href;
        var modal = document.getElementById("modal"); 
        if(!document.getElementById("ayeframe")) {
          var iframe = document.createElement('iframe');
          iframe.src = linkSrc;
          iframe.id = "ayeframe";
          iframe.scrolling = "no";
          modal.appendChild(iframe);
        }
        modal.classList.add("active");
        e.preventDefault();
        resizeIframe(iframe);
      });

      var modalbg = document.getElementById("modal");

      modalbg.addEventListener('click',function(e) {
        if (modalbg.classList.contains("active")) {
          modalbg.classList.remove("active");
        }
      });
    }

    if(document.getElementById("poa")) {
      
      let poa = document.getElementById("poa");

      poa.addEventListener('click',function(e) {
        var linkSrc = poa.href;
        var modaly = document.getElementById("modaly"); 
        if(!document.getElementById("ayeframe")) {
          var iframe = document.createElement('iframe');
          iframe.src = linkSrc;
          iframe.id = "ayeframe";
          iframe.scrolling = "no";
          modaly.appendChild(iframe);
        }
        modaly.classList.add("active");
        e.preventDefault();
        resizeIframe(iframe);
      });

      var modalybg = document.getElementById("modaly");

      modalybg.addEventListener('click',function(e) {
        if (modalybg.classList.contains("active")) {
          modalybg.classList.remove("active");
        }
      });
    }

    if (document.getElementById('newsletterForm')) {

      const daform = document.getElementById('newsletterForm');
      form.addEventListener('freeform-ready', function(event) {
        const freeform = event.target.freeform;
        freeform.addOnAfterAjaxSubmit((event, daform, response) => {
          // Do something on a successful ajax submit
          console.log("I think it happened");
          dataLayer.push({'event':'signedUp'});
        })
      });

    }
  });

  function uppateCategoryClasses() {
    const thisPage = window.location.protocol + "//" + window.location.host + window.location.pathname;
    document.querySelectorAll('#collectionsort li a').forEach( function(navListLink) {
      // console.log(thisPage);
      // console.log(navListLink.href);
      if ( thisPage == navListLink.href ) {
        navListLink.classList.add("active");
      } else {
        navListLink.classList.remove("active");
      }
    });
  }

function helloJewellerysort() {

  if (document.getElementById('jewellerysort')) {

    let jewelleryNav = document.getElementById('jewellerysort');

    setTimeout( function(e) {
      jewelleryNav.classList.add('hello');
    }, 300);
  }
}

function animateProducts() {
  if (document.querySelector('.containerCat')) {
    document.querySelector('.containerCat').classList.remove('aurevoir');
    document.querySelector('.containerCat').classList.add('bonjour');
  }
}
function deAnimateProducts() {
  if (document.querySelector('.containerCat')) {
    document.querySelector('.containerCat').classList.add('aurevoir');
    document.querySelector('.containerCat').classList.remove('bonjour');
  }
}

function killClasses() {
  if (document.querySelector('.containerCat')) {
    document.querySelector('.containerCat').classList.remove('bonjour');
  }
}

function resizeBannerGap() {
  const topBanner = document.getElementById('topBanner');
  const app = document.getElementById('app');
  const header = document.getElementById('header');
  
  let height = topBanner.offsetHeight;
  
  app.style.marginTop = height + 'px';
  header.style.marginTop = height + 'px';
}

if (document.getElementById('topBanner')) {
  resizeBannerGap();
  window.onresize = resizeBannerGap;
}

//Swup functions

function oldPageScripts() {
  categoryMixDie();
  destroyFooterScripts();
};

function newPageScripts() {
  uppateCategoryClasses();
  helloJewellerysort();
  categoryMix();
  Waypoint.refreshAll();
  // footerScripts();
  deAnimateProducts();
  setTimeout( function() {
    animateProducts();
  }, 1000);
  setTimeout( function() {
    killClasses();
  }, 2000);
};


(function(window, document, undefined) {
  "use strict";

  // List of Video Vendors embeds you want to support
  var players = ['iframe[src*="youtube.com"]', 'iframe[src*="youtube-nocookie.com"]'];

  // Select videos
  var fitVids = document.querySelectorAll(players.join(","));

  // If there are videos on the page...
  if (fitVids.length) {
    // Loop through videos
    for (var i = 0; i < fitVids.length; i++) {
      // Get Video Information
      var fitVid = fitVids[i];
      var width = fitVid.getAttribute("width");
      var height = fitVid.getAttribute("height");
      var aspectRatio = height / width;
      var parentDiv = fitVid.parentNode;

      // Wrap it in a DIV
      var div = document.createElement("div");
      div.className = "fitVids-wrapper";
      div.style.paddingBottom = aspectRatio * 100 + "%";
      parentDiv.insertBefore(div, fitVid);
      fitVid.remove();
      div.appendChild(fitVid);

      // Clear height/width from fitVid
      fitVid.removeAttribute("height");
      fitVid.removeAttribute("width");
    }
  }
})(window, document);